export const PAYMENT_LINKS = {
    orientation: {
        essentiel: { stripe: 'https://buy.stripe.com/3cIdR27Gi74t9QEfwi4Vy0d', fedapay: null },
        premium: { stripe: 'https://buy.stripe.com/28E6oA0dQfAZd2Q6ZM4Vy0c', fedapay: null },
        elite: { stripe: 'https://buy.stripe.com/4gM14g3q20G52ocbg24Vy0b', fedapay: null },
    },
    visa: {
        essentiel: { stripe: 'https://buy.stripe.com/28EcMYaSu74t3sgese4Vy0a', fedapay: null },
        premium: { stripe: 'https://buy.stripe.com/7sY6oAgcOagF3sg1Fs4Vy09', fedapay: null },
        elite: { stripe: 'https://buy.stripe.com/14A28k3q2ewV4wk5VI4Vy08', fedapay: null },
    },
    permis: {
        essentiel: { stripe: 'https://buy.stripe.com/28E9AM8KmfAZ8MAfwi4Vy07', fedapay: null },
        premium: { stripe: 'https://buy.stripe.com/28EeV63q2dsR8MAbg24Vy06', fedapay: null },
        elite: { stripe: 'https://buy.stripe.com/8x23cod0C9cB0g4gAm4Vy05', fedapay: null },
    },
    web: {
        vitrine: { stripe: 'https://buy.stripe.com/9B68wId0CagFd2Qdoa4Vy04', fedapay: null },
        business: { stripe: 'https://buy.stripe.com/8x2fZa7Gi88x9QE1Fs4Vy03', fedapay: null },
    },
    social: {
        starter: { stripe: 'https://buy.stripe.com/aFa3co1hUgF37Iwdoa4Vy02', fedapay: null },
        growth: { stripe: 'https://buy.stripe.com/bJe6oA4u674t1k8ck64Vy01', fedapay: null },
        premium: { stripe: 'https://buy.stripe.com/14AaEQ6CedsR6EsabY4Vy00', fedapay: null },
    },
};
